<template>
  <div class="index">
    <div class="main-wrap">
      <div>
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <div class="taskEdit">
              <div class="basic-title"><em>编辑模板</em></div>
              <el-form
                :model="formData"
                class="editTable">
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155">任务名称：</span>
                      <el-input
                        class="input452"
                        v-model="formData.foregroundTask"/>
                      <span class="rules-span">任务名称按照文件名标准命名，不能包含"+"和"/"等特殊符号</span>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155">任务别名：</span>
                      <el-input
                        class="input452"
                        v-model="formData.backgroundTask"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155 fl">任务说明：</span>
                      <quill-editor
                        v-model="formData.taskSpecification"
                        class="quillEditor452"
                        :options="editorOption"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155">任务类型：</span>
                      <el-select
                        v-model="formData.taskTypeChecked"
                        placeholder="请选择">
                        <el-option
                          v-for="item in formData.taskTypes"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"/>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155"> 图标1（无颜色）：</span>
                      <jm-upload
                        class="upload-demo"
                        ref="upload"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="handleSuccess"
                        :data="{type: '1'}"
                        action="/newfib.php/index/Task/uploadFile">
                        <el-button
                          slot="trigger"
                          size="small"
                          type="primary"
                          class="inline-block" >选取图片</el-button>
                      </jm-upload>
                      <div
                        v-for="item in logoPicture"
                        :key="item"
                        v-if="item.logo_type === 1"
                        class="logoImg" >
                        <img
                          height="40"
                          :src="item.picurl" >
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155"> 图标2（有颜色）：</span>
                      <jm-upload
                        class="upload-demo"
                        ref="upload"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="handleSuccess"
                        :data="{type: '2'}"
                        action="/newfib.php/index/Task/uploadFile">
                        <el-button
                          slot="trigger"
                          size="small"
                          type="primary" >选取图片</el-button>
                      </jm-upload>
                      <div
                        v-for="item in logoPicture"
                        :key="item"
                        v-if="item.logo_type === 2"
                        class="logoImg">
                        <img
                          height="40"
                          :src="item.picurl" >
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item>
                      <el-col :span="24">
                        <span class="span155 fl"> 上传表格：</span>
                        <jm-materialCloudsOfTask
                          class="myUpload"
                          :title="'上传表格'"
                          upload-url='/newfib.php/index/Task/uploadFile'
                          :upload-data="{
                            type:'3',
                            taskId: taskId,
                          }"
                        />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <span class="span155"/>
                      <el-button
                        type="primary"
                        @click="saveForm"
                        class="btn-submit">提交</el-button>
                      <router-link
                        target="_blank"
                        :to="{ name: 'tasklist',params: { country: country}}">
                        <el-button class="btn-return">返回</el-button>
                      </router-link>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
    .myUpload{
        width: 0px;
        display: inline-block;
    }
    .logoImg{
        display: inline;
        margin-left: 94px;
        margin-bottom: -11px;
    }
</style>
<script>
import '@/assets/jsmind/style/jsmind.css';
import '@/assets/css/task-edit.css';
import crumbs from '@/components/tool/crumbs.vue';
import materialCloudsOfTask from '@/pages/task/materialCloudsOfTask.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  data() {
    return {
      taskId: this.$route.params.taskId,
      seen: true,
      country: this.$route.params.country,
      type: '',
      logoPicture: [],
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video']
          ]
        }
      },
      file: null,
      uploadMaterial: [],
      formData: {
        foregroundTask: '',
        backgroundTask: '',
        taskSpecification: '',
        taskTypeChecked: '',
        taskTypes: [],
      },
      // 上传材料
      crmOfferId: {}, // 公共id
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-materialCloudsOfTask': materialCloudsOfTask,
    quillEditor
  },
  methods: {
    isShow() {
      this.seen = false;
    },
    isSeen() {
      this.seen = true;
    },
    // 获取初始化数据
    getEditInfo() {
      let taskId = this.$route.params.taskId;
      this.$http._get({
        url: `/index/Task/getEditInfo?fileId=${taskId}`
      }).then(({ data }) => {
        console.log(data);
        this.formData.foregroundTask = data.taskInfo.file_name;
        this.formData.backgroundTask = data.taskInfo.file_bname;
        this.formData.taskSpecification = data.taskInfo.task_explaination;
        this.formData.taskTypes = data.taskType;
        this.logoPicture = data.taskLogos;
        this.uploadMaterial = data.uploadMaterial;
        console.log(this.logoPicture);
        console.log(data.taskType[0].id);
        console.log(this.formData.taskTypeChecked);
      });
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    // 直接上传之前需要进行大小的验证，否则无法调用后台的方法
    beforeUpload(file) {
      console.log('test', file);
      let maxSize = 1024 * 1024 * 4;
      if (file === null) {
        this.$message.error('没有文件,请选择文件！');
        return false;
      } else if (file.size > maxSize) {
        this.$message.error('文件大小不能超过4M!');
        return false;
      }
    },
    // 上传成功之后
    handleSuccess(response, file) {
      console.log(response);
      console.log(file);
      if (response.result === 0) {
        let material = response.data;
        console.log('test', material);
        let taskId = this.$route.params.taskId;
        let fileSize = Math.floor(file.size / 1024);
        this.addlogo(material.imgurl, taskId, file.name, fileSize, material.type);
      } else {
        this.$message.error(response.msg);
      }
    },
    addlogo(picurl, taskId, picname, imgsize, type) {
      let data = {
        picurl: picurl,
        taskId: taskId,
        picname: picname,
        imgsize: imgsize,
        type: type
      };
      this.$http
        ._post({
          url: '/index/Task/addLogo',
          data: data,
        })
        .then((data) => {
          console.log(data);
          if (data.result === 0) {
            this.$message.success('上传成功');
            this.getEditInfo();
          }
        });
    },
    saveForm: function () {
      let taskId = this.$route.params.taskId;
      let country = this.$route.params.country;
      let data = {
        task_explaination: this.formData.taskSpecification,
        id: taskId,
        tp_country: country,
        task_type: this.formData.taskTypeChecked,
        file_name: this.formData.foregroundTask,
        file_bname: this.formData.backgroundTask,
      };
      this.$http
        ._post({
          url: '/index/Task/saveForm',
          data: data,
        })
        .then((data) => {
          console.log(data);
          if (data.result === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    submitUpload(type) {
      this.$refs.upload.submit();
      this.uploadFile(type);
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePreview(file) {
      console.log(file);
    }
  },
  computed: {
  },
  mounted() {
    this.getEditInfo();
  },
};
</script>
